// Generated by Melange

import * as CamlinternalLazy from "melange/camlinternalLazy.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__Lazy from "melange/lazy.js";
import * as Stdlib__Sys from "melange/sys.js";

function apply_lazy(f) {
  if (typeof Stdlib__Sys.backend_type === "number") {
    return Curry._1(f, undefined);
  }
  const f$1 = Stdlib__Lazy.from_fun(f);
  return function (x) {
    return Curry._1(CamlinternalLazy.force(f$1), x);
  };
}

export {
  apply_lazy ,
}
/* No side effect */
